import { render } from "./Apetrechos.vue?vue&type=template&id=db634ca0&scoped=true"
import script from "./Apetrechos.vue?vue&type=script&lang=js"
export * from "./Apetrechos.vue?vue&type=script&lang=js"

import "./Apetrechos.vue?vue&type=style&index=0&id=db634ca0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db634ca0"]])

export default __exports__